import React, { useEffect, useState } from 'react';
import axios from "axios";
import backgroundVideo from './assets/background.mp4';

function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

const Logo = () => {
  return (
    <a href="https://lubyo.com" className="flex-col flex items-end" target="_blank">
      <span
        className="text-2xl font-bold tracking-tighter text-white leading-none"
      >
        LUBYO
      </span>
      <svg width="75" height="4" xmlns="http://www.w3.org/2000/svg">
        <rect width="15" height="4" x="0" fill="rgb(174, 110, 151)" />
        <rect width="15" height="4" x="15" fill="rgb(192, 106, 130)" />
        <rect width="15" height="4" x="30" fill="rgb(217, 98, 106)" />
        <rect width="15" height="4" x="45" fill="rgb(224, 130, 83)" />
        <rect width="15" height="4" x="60" fill="rgb(222, 125, 81)" />
      </svg>
    </a>
  );
};


function App() {
  const [overlayDark, setOverlayDark] = useState(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  useEffect(() => {
     setTimeout(() => setOverlayDark(true), 100);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    try {
      const response = await axios.post("/subscribe", { email });
      console.log(response.data);
      setStatus("success");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <div>
    <div className="relative w-full h-screen overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={backgroundVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      <div
       className={`absolute inset-0 bg-black transition-opacity duration-[5000ms] z-0 ${
        overlayDark ? 'opacity-60' : 'opacity-0'
      }`}
      />

      {/* Logo centered */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 z-10">
        <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-semibold font-dmserif max-w-2xl w-full">
          THE WORKATIONIST
        </h1>
        <p className="text-white text-base sm:text-lg lg:text-xl font-quicksand max-w-2xl w-full mt-6 opacity-90">
          A collection of the world’s most inspiring colivings –<br/> visited & selected by us, for you
        </p>
      </div>
      {/* Footer text */}
      <div className="absolute bottom-4 items-center content-center gap-4 right-4 z-10 text-white text-opacity-75 text-sm">
        Powered by
        <Logo/>
      </div>
    </div>

    <section className="w-full h-screen flex flex-col lg:flex-row">
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full">
    <img
      src={require('./assets/mediterranean.jpg')}
      alt="Workationist"
      className="w-full h-full object-cover"
    />
  </div>
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full flex items-center justify-center px-6 py-10 bg-sand border-b-[1px] border-olive border-opacity-25">
    <div className="max-w-xl text-center lg:text-left">
      <h2 className="text-3xl sm:text-4xl font-bold font-dmserif text-olive mb-6">
        THE WORKATIONIST
      </h2>
      <p className="text-lg font-quicksand text-bleck mb-4">
        A handpicked collection of the world’s most inspiring colivings &mdash; designed for deep work,
        real connections and a true sense of belonging.
      </p>
      <p className="text-lg font-quicksand text-olive text-opacity-50 font-semibold italic">
        Not listed. Chosen. Visited & Experienced.
      </p>
    </div>
  </div>
</section>
{/* Section 3 */}
<section className="w-full h-screen flex flex-col lg:flex-row">
  {/* Text Content */}
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full flex items-center justify-center px-6 py-10 bg-sand border-b-[1px] border-olive border-opacity-25">
    <div className="max-w-xl text-center lg:text-left">
      <h2 className="text-3xl sm:text-4xl font-bold font-dmserif text-olive mb-6">
        THE RIGHT PLACES CHANGE EVERYTHING
      </h2>
      <p className="text-lg font-quicksand text-black">
        A workation is more than just working from somewhere beautiful.
      </p>
    </div>
  </div>

  {/* Image */}
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full">
    <img
      src={require('./assets/workation.jpg')}
      alt="Workation"
      className="w-full h-full object-cover"
    />
  </div>
</section>
<section className="w-full min-h-screen px-6 py-16 flex flex-col items-center text-center bg-sand border-b-[1px] border-olive border-opacity-25">
  {/* Title and Description */}
  <div className="max-w-3xl mb-12">
    <h2 className="text-2xl sm:text-4xl font-bold font-dmserif text-olive mb-6">
      BLURRY FOR NOW &mdash; UNFORGETTABLE SOON
    </h2>
    <p className="text-lg font-quicksand text-black">
      We personally visit, stay and experience each coliving before it makes the list.
      These places aren’t just work-friendly — they’re workation magic.
      Stay tuned — soon, you’ll see why.
    </p>
  </div>

  {/* Image Grid */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
    {/* Card 1 */}
    <div className="flex flex-col items-center">
      <img
        src={require('./assets/canary-islands.jpg')}
        alt="Canary Islands, Spain"
        className="w-full aspect-square object-cover rounded-xl shadow-md"
      />
      <p className="mt-3 text-base font-medium font-sans text-olive">
        Canary Islands, Spain
      </p>
    </div>

    {/* Card 2 */}
    <div className="flex flex-col items-center">
      <img
        src={require('./assets/tuscany.jpg')}
        alt="Tuscany, Italy"
        className="w-full aspect-square object-cover rounded-xl shadow-md"
      />
      <p className="mt-3 text-base font-medium font-sans text-olive">
        Tuscany, Italy
      </p>
    </div>

    {/* Card 3 */}
    <div className="flex flex-col items-center">
      <img
        src={require('./assets/picauville.jpg')}
        alt="Picauville, France"
        className="w-full aspect-square object-cover rounded-xl shadow-md"
      />
      <p className="mt-3 text-base font-medium font-sans text-olive">
        Picauville, France
      </p>
    </div>
  </div>
</section>
<section className="w-full h-screen flex flex-col lg:flex-row bg-sand border-b-[1px] border-olive border-opacity-25">
  {/* Image (Black & White) */}
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full">
    <img
      src={require('./assets/why-this-matters.jpg')}
      alt="Why This Matters"
      className="w-full h-full object-cover"
    />
  </div>

  {/* Text */}
  <div className="w-full lg:w-1/2 h-1/2 lg:h-full flex items-center justify-center px-6 py-10">
    <div className="max-w-xl text-center lg:text-left">
      <h2 className="text-2xl sm:text-4xl font-bold font-dmserif text-olive mb-6">
        WHY THIS MATTERS
      </h2>
      <p className="text-lg font-quicksand italic mb-4 text-black">
        "Some places look great on Instagram. But we believe a true workation is about deep work,
        real connections and effortless living. That’s why we personally visit and select every
        coliving—so you know exactly where to go."
      </p>
      <p className="text-base font-semibold font-quicksand mt-4 text-olive text-opacity-75">
        Roman Matyushkin
      </p>
    </div>
  </div>
</section>

{/* Section 6: Stay in Touch */}
<section className="w-full min-h-screen flex flex-col bg-sand pt-16">
  {/* Top Content */}
  <div className="flex flex-1 flex-col items-center justify-center text-center px-6">
    <h2 className="text-2xl sm:text-4xl font-bold mb-12 text-olive font-dmserif">
      THE WORKATIONIST is launching soon...
    </h2>
    <h3 className="text-lg sm:text-xl font-semibold font-quicksand mb-6 text-olive text-opacity-75">
      STAY IN TOUCH
    </h3>
    <p className="max-w-2xl text-base sm:text-lg font-quicksand text-black">
      Be the first to access our handpicked coliving spaces before we reveal them to the world
    </p>

    <form onSubmit={handleSubmit} className="flex flex-col gap-2 w-full lg:max-w-xl max-w-sm mt-12 font-quicksand">
      <input
        type="email"
        name="email"
        required
        placeholder="Your email address"
        className="border p-2 rounded text-olive border-olive focus:outline-none focus-visible:outline-none"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button type="submit" className="bg-olive text-white p-2 rounded" disabled={!isValidEmail(email) || status === "success"}>
        {status === "success" ? "Thank you" : "Subscribe"}
      </button>
      {status === "error" && <p className="text-red-600">Oops! Something went wrong.</p>}
    </form>
  </div>

  {/* Footer block with distinct background */}
  <footer className="w-full bg-olive mt-16 px-6 py-10">
    <div className="max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-10 lg:space-y-0 text-sm font-quicksand text-sand">
      
      {/* Left: Address & Contact */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <p className="font-semibold mb-1">Address:</p>
          <p>Gateway Workspace</p>
          <p>Weyertal 109, 50931 Cologne</p>
        </div>
        <div>
          <p className="font-semibold mb-1">Contacts:</p>
          <a href="mailto:workationist@lubyo.com" target="_blank" className="underline">workationist@lubyo.com</a>
        </div>
      </div>

      {/* Right: Logo */}
      <div className="flex flex-col items-start lg:items-end font-sans">
        <p className="mb-2">Powered by</p>
        <Logo />
      </div>
    </div>
  </footer>
</section>
</div>
  );
}

export default App;
